var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitcoin (BTC) Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#f7931a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.19,14c.31-2.1-1.28-3.22-3.47-4l.71-2.85L18.7,6.78,18,9.54l-1.38-.33.69-2.78L15.6,6l-.71,2.84-1.11-.26h0L11.4,8l-.46,1.85s1.28.29,1.26.31a.92.92,0,0,1,.8,1l-.8,3.23.18.06-.19,0-1.13,4.53a.63.63,0,0,1-.79.41S9,19,9,19l-.86,2,2.25.56,1.23.32-.72,2.87,1.73.43.71-2.84,1.38.36L14,25.52l1.73.43.71-2.87c3,.56,5.17.34,6.1-2.33.75-2.15,0-3.38-1.59-4.19A2.76,2.76,0,0,0,23.19,14Zm-4,5.54c-.53,2.14-4.15,1-5.32.69l.95-3.8C16,16.74,19.8,17.32,19.24,19.56ZM19.77,14c-.48,1.95-3.49,1-4.47.72l.86-3.45C17.14,11.5,20.28,12,19.77,14Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.db0d23b090b40c975df4e9aa5b88ab55.svg";
export { ForwardRef as ReactComponent };